import React from 'react';
import { dispatch } from '@rematch/core';
import { withRouter } from 'react-router-dom';
import AccountRegistration from './../drive/Modal/AccountRegistration'
import Mainpage from './main'

class Home extends React.Component {

    componentWillMount() {
        dispatch.account.getAllAccounts(this.props.user._id);
        dispatch.content.setContentComponentMounted(false);
        if(this.props.selectedAccount && this.props.selectedAccount._id){
            dispatch.account.updateSelectedAccountState(this.props.selectedAccount);
        }
    }

    isWorkspaceOwner = () => {
        if (this.props.selectedAccount.ownerId === this.props.user._id) {
            return true;
        }
        return false;
    };
    render() {

        return (
            <div>
                {
                    ( this.props.selectedAccount.accountSetupStateNumber === 0 && this.isWorkspaceOwner()) ?
                        <AccountRegistration accountData={this.props.selectedAccount}
                            accountLogoObjectCloudinary={this.props.accountLogoObjectCloudinary}
                            loaderStatus={this.props.loaderStatus}
                            updateAccountLoader={this.props.updateAccountLoader}
                            user={this.props.user}
                            {...this.props}
                        /> :
                            <Mainpage
                                {...this.props}
                            />
                }
            </div>
        )
    }
}

export default withRouter(Home);
